<template>
  <svg viewBox="0 0 157 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="16.2571"
      y="88.6859"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 16.2571 88.6859)"
      fill="#A4E392"
    />
    <rect
      x="81.3142"
      y="89.6"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 81.3142 89.6)"
      fill="#306739"
    />
    <rect
      x="117.886"
      y="89.6"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 117.886 89.6)"
      fill="#78D382"
    />
    <rect
      x="15.3428"
      y="69.4857"
      width="10.9714"
      height="10.9714"
      rx="2.92571"
      transform="rotate(180 15.3428 69.4857)"
      fill="#D4F8B5"
    />
    <rect
      x="81.3142"
      y="71.3143"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 81.3142 71.3143)"
      fill="#51A456"
    />
    <rect
      x="117.886"
      y="71.3143"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 117.886 71.3143)"
      fill="#78D382"
    />
    <rect
      x="81.3142"
      y="53.0286"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 81.3142 53.0286)"
      fill="#78D382"
    />
    <rect
      x="98.6858"
      y="33.8286"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 98.6858 33.8286)"
      fill="#A4E392"
    />
    <rect
      x="35.4573"
      y="89.6002"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 35.4573 89.6002)"
      fill="#78D382"
    />
    <rect
      x="99.6001"
      y="89.6"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 99.6001 89.6)"
      fill="#51A456"
    />
    <rect
      x="135.257"
      y="88.6857"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 135.257 88.6857)"
      fill="#78D382"
    />
    <rect
      x="63.0286"
      y="89.6"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 63.0286 89.6)"
      fill="#306739"
    />
    <rect
      x="34.543"
      y="70.4"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 34.543 70.4)"
      fill="#A4E392"
    />
    <rect
      x="99.6001"
      y="71.3143"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 99.6001 71.3143)"
      fill="#51A456"
    />
    <rect
      x="135.257"
      y="70.4"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 135.257 70.4)"
      fill="#78D382"
    />
    <rect
      x="97.6287"
      y="14.6285"
      width="10.9714"
      height="10.9714"
      rx="2.92571"
      transform="rotate(180 97.6287 14.6285)"
      fill="#A4E392"
    />
    <rect
      x="61.6287"
      y="51.6285"
      width="10.9714"
      height="10.9714"
      rx="2.92571"
      transform="rotate(180 61.6287 51.6285)"
      fill="#A4E392"
    />
    <rect
      x="80.2571"
      y="33.8286"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 80.2571 33.8286)"
      fill="#78D382"
    />
    <rect
      x="63.0286"
      y="71.3143"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 63.0286 71.3143)"
      fill="#51A456"
    />
    <rect
      x="35.4573"
      y="107.886"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 35.4573 107.886)"
      fill="#78D382"
    />
    <rect
      x="99.6001"
      y="107.886"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 99.6001 107.886)"
      fill="#51A456"
    />
    <rect
      x="135.257"
      y="106.971"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 135.257 106.971)"
      fill="#78D382"
    />
    <rect
      x="63.0286"
      y="107.886"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 63.0286 107.886)"
      fill="#51A456"
    />
    <rect
      x="34.543"
      y="125.257"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 34.543 125.257)"
      fill="#A4E392"
    />
    <rect
      x="99.6001"
      y="126.171"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 99.6001 126.171)"
      fill="#78D382"
    />
    <rect
      x="63.0286"
      y="126.171"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 63.0286 126.171)"
      fill="#78D382"
    />
    <rect
      x="16.2571"
      y="106.971"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 16.2571 106.971)"
      fill="#A4E392"
    />
    <rect
      x="81.3142"
      y="107.886"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 81.3142 107.886)"
      fill="#51A456"
    />
    <rect
      x="117.886"
      y="107.886"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 117.886 107.886)"
      fill="#78D382"
    />
    <rect
      x="15.3428"
      y="124.343"
      width="10.9714"
      height="10.9714"
      rx="2.92571"
      transform="rotate(180 15.3428 124.343)"
      fill="#D4F8B5"
    />
    <rect
      x="81.3142"
      y="126.171"
      width="14.6286"
      height="14.6286"
      rx="1.46286"
      transform="rotate(180 81.3142 126.171)"
      fill="#78D382"
    />
    <rect
      x="116.971"
      y="125.257"
      width="12.8"
      height="12.8"
      rx="2.19428"
      transform="rotate(180 116.971 125.257)"
      fill="#78D382"
    />
  </svg>
</template>